import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { forkJoin, map, Observable } from 'rxjs';
import { Translation, TranslocoLoader } from '@ngneat/transloco';

@Injectable({
    providedIn: 'root'
})
export class TranslocoHttpLoader implements TranslocoLoader
{
    /**
     * Constructor
     */
    constructor(
        private _httpClient: HttpClient)
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get translation
     *
     * @param lang
     */
    getTranslation(lang: string): Observable<Translation>
    {
        const base = this._httpClient.get<Translation>(`./assets/i18n/${lang}.json?v=${new Date().getTime()}`);

        return base;


        return forkJoin([
            base,
            this._httpClient.get(`/assets/i18n/${lang}.vendor.json`)
        ]).pipe(map(([translation, vendor]) => {
            return { ...translation, ...vendor }
        }))
    }
}
